/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import {
  css,
  SerializedStyles,
} from "@emotion/core"
import { Color } from "./colors"

export enum FontSize {
  extraLarge = "32.0px",
  mediumLarge = "28.0px",
  large = "24.0px",
  largeMedium = "22.0px",
  medium = "20.0px",
  regular = "16.0px",
  small = "14.0px",
  extraSmall = "12.0px",
  mediumSmall = "10.0px",
}

export enum FontWeight {
  light = 300,
  regular = 400,
  medium = 500,
  bold = 700,
  extraBold = 900,
}
class Typography {
  constructor(
    public size: FontSize,
    public weight: FontWeight,
    public color: Color = Color.black,
  ) {}

  public getCSS(): SerializedStyles {
    return css`
      font-size: ${this.size};
      font-weight: ${this.weight};
      color: ${this.color};
      letter-spacing: 0;
    `
  }
}
export const Typographies = {
  Body1: new Typography(
    FontSize.small,
    FontWeight.medium,
  ).getCSS(),
  Body2: new Typography(
    FontSize.small,
    FontWeight.regular,
  ).getCSS(),
  Button: new Typography(
    FontSize.regular,
    FontWeight.bold,
  ).getCSS(),
  Caption: new Typography(
    FontSize.extraSmall,
    FontWeight.regular,
  ).getCSS(),
  CaptionBold: new Typography(
    FontSize.extraSmall,
    FontWeight.medium,
  ).getCSS(),
  Headline1: new Typography(
    FontSize.extraLarge,
    FontWeight.medium,
  ).getCSS(),
  Headline2: new Typography(
    FontSize.large,
    FontWeight.regular,
  ).getCSS(),
  Headline3: new Typography(
    FontSize.medium,
    FontWeight.medium,
  ).getCSS(),
  Headline4: new Typography(
    FontSize.regular,
    FontWeight.medium,
  ).getCSS(),
  Headline5: new Typography(
    FontSize.regular,
    FontWeight.regular,
  ).getCSS(),
  Headline6: new Typography(
    FontSize.mediumSmall,
    FontWeight.medium,
  ).getCSS(),
  Headline7: new Typography(
    FontSize.mediumSmall,
    FontWeight.regular,
  ).getCSS(),
}
